import * as React from "react";

import { faCheckCircle, faQuestionCircle, faTimesCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Tooltip } from 'reactstrap';
import { GetRagClass, IPackInfo } from '../../../../../Types';

export enum RAG {
    Green = "Green",
    Amber = "Amber",
    Red = "Red",
    Grey = "Grey"
}

export interface IRagIconProps {
    icon: IconDefinition;
    class: string;
    messageText?: string;
    messageType?: RAG;
    isVisable: boolean;
}

export interface IRagIconState {
    tooltipOpen: boolean;
}

export class HistoryRagIcon extends React.Component<IRagIconProps, IRagIconState> {

    tooltipTargetRef: React.RefObject<HTMLDivElement>

    constructor(props: IRagIconProps) {
        super(props);
        this.state = {
            tooltipOpen: false
        };

        this.tooltipTargetRef = React.createRef<HTMLDivElement>();
    }

    private callOutId = Math.round(Math.random() * 9999999);
    
    static getRagMultiple = (packs: IPackInfo[]): JSX.Element => {
        var pack: IPackInfo = { ragClass: RAG.Green, ragIcon: "fa-check-circle"} as IPackInfo;
        packs.forEach((p: IPackInfo) => {
            if ((pack.ragClass == RAG.Green) || (pack.ragClass == RAG.Amber && p.ragIcon != "fa-check-circle")) {
                pack = p;
            }
        })
        return HistoryRagIcon.getRags(pack);
    };

    static getRagSingle = (packInfo: IPackInfo): JSX.Element => {
        return HistoryRagIcon.getRags(packInfo);
    };

    private static getRags = (packInfo: IPackInfo): JSX.Element => {

        return <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            <HistoryRagIcon
                icon={faCheckCircle}
                class={`text-${GetRagClass(packInfo.ragClass)}`}
                isVisable={packInfo.ragClass === RAG.Green}
                    //<i className={`fa fa-check-circle green ${packInfo.ragClass === RAG.Green && "visible"}`} aria-hidden="true"></i>}
                messageText={undefined}
                messageType={undefined}
            />
            <HistoryRagIcon
                //domElement={<i className={`fa fa-check-circle yellow ${packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-check-circle" && "visible"}`} aria-hidden="true"></i>}
                icon={faCheckCircle}
                class={`text-${GetRagClass(packInfo.ragClass)}`}
                isVisable={packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-check-circle"}
                messageText={packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-check-circle" ? packInfo.warning || packInfo.information : undefined}
                messageType={RAG.Amber}
            />
            <HistoryRagIcon
                //domElement={<i className={`fa fa-times-circle yellow ${packInfo.ragClass === RAG.Amber && packInfo.ragIcon === "fa-times-circle" && "visible"}`} aria-hidden="true"></i>}
                icon={faTimesCircle}
                class={`text-${GetRagClass(packInfo.ragClass)}`}
                isVisable={packInfo.ragClass === RAG.Amber && packInfo.ragIcon !== "fa-check-circle"}
                messageText={packInfo.ragClass === RAG.Amber && packInfo.ragIcon !== "fa-check-circle" ? packInfo.warning || packInfo.information : undefined}
                messageType={RAG.Amber}
            />
            <HistoryRagIcon
                //domElement={<i className={`fa fa-times-circle red ${packInfo.ragClass === RAG.Red && "visible"}`} aria-hidden="true"></i>}
                icon={faTimesCircle}
                class={`text-${GetRagClass(packInfo.ragClass)}`}
                isVisable={packInfo.ragClass === RAG.Red}
                messageText={packInfo.ragClass === RAG.Red ? packInfo.warning || packInfo.information : undefined}
                messageType={RAG.Red}
            />
            <HistoryRagIcon
                icon={faQuestionCircle}
                class={`text-${GetRagClass(packInfo.ragClass)}`}
                isVisable={packInfo.ragClass === RAG.Grey}
                messageText={packInfo.ragClass === RAG.Grey ? packInfo.warning || packInfo.information : undefined}
                messageType={RAG.Grey}
            />
        </div>;
    };

    toggle = () => {
        this.setState((prevState) => ({ tooltipOpen: !prevState.tooltipOpen }));
    }

    render() {
        return (
            <div >
                <div  ref={this.tooltipTargetRef}>
                    {this.props.isVisable && <FontAwesomeIcon icon={this.props.icon} className={this.props.class} />}
                </div>
                {this.props.messageText &&
                    <Tooltip placement="bottom" isOpen={this.state.tooltipOpen} target={this.tooltipTargetRef} toggle={this.toggle}>
                    {this.props.messageText}
                </Tooltip>}
            </div>
        );
    }
}
